export default __webpack_public_path__ + "static/media/image08.b59e4a61.jpg";